import React from 'react';

const Footer = () => {
  return (
    <footer className="w-full text-textPrimary mb-1 opacity-80 fixed bottom-0 left-0 z-50">
      <div className="text-center ">
        <p className="text-gray-400 ">&copy; 2024 LegalAI. All rights reserved.</p>
        
      </div>
    </footer>
  );
};

export default Footer;
